import {
  React,
  Heading,
  Text,
  Input,
  Container,
  Row,
  Col,
  Button,
} from "mondrian-react";
import { useEffect, useState, useCallback } from "react";
import "./style.scss";
import { logger } from "utils/logger";
import { handlePhoneMask } from "utils/handlePhoneMask.js";
import { reportGA4, reportPageViewGA4 } from "utils/pushDataLayer";
import useIsPJ from "hooks/useIsPJ";

const AuthenticationStep = ({
  onClickHandleCodeAuthentication,
  otpTransactionId,
  onClickHandleValidate,
  msisdn,
  onClickBackStep,
  isError,
  setDialogObject
}) => {
  const [tokenValue, setTokenValue] = React.useState("");
  const [buttonDisabled, setButtonDisabled] = React.useState(true);
  const EXPIRATION_TIME = parseInt(
    process.env.REACT_APP_EXPIRATION_TIME_OTP_TOKEN
  );
  const onlyNumbers = (value) => value.replace(/\D/g, "");
  const maxLength = (value, max) => value.substring(0, max);
  const exceptThisSymbols = ["e", "E", "+", "-", ".", ",", "ArrowDown", "ArrowUp"];

  const isPJ = useIsPJ();

  // COUNTING
  const [time, setTime] = useState(EXPIRATION_TIME);

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  const [minuteLeft, minuteRight] = String(minutes).padStart(2, "0").split("");
  const [secondLeft, secondRight] = String(seconds).padStart(2, "0").split("");

  const handleOnChange = useCallback((e) => {
    const onlyNumbersValue = onlyNumbers(e.target.value);
    const trimValue = maxLength(onlyNumbersValue, 6);
    e.target.value = trimValue;
    setTokenValue(e.target.value);
    if (onlyNumbersValue.length > 6) {
      setTokenValue(e.target.value);
    }
    handleInputError(e.target);
  }, []);

  const handleInputError = (target) => {
    const value = String(target.value);
    if (value.length < 6) {
      setButtonDisabled(true)
    } else {
      setButtonDisabled(false)
    }
  };

  useEffect(() => {
    reportPageViewGA4({ customTitle: 'validacao_do_token' })
  }, [])

  useEffect(() => {
    if (time === 0) {
      reportGA4({
        event: "callback",
        customTitle: 'validacao_do_token',
        customCallback: 'erro:codigo_expirado'
      })
      setDialogObject({
        title: "Código de segurança",
        description: ["O código enviado expirou!"],
        function: resendCodeAuth,
        isOpen: true,
      })
    } else {
      setTimeout(() => {
        if (time > 0) {
          setTime(time - 1);
        }
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);

  const propsButtonContinue = {
    onClick: () => {
      validateCodeAuth()
      reportGA4({ customTitle: 'validacao_do_token:continuar' })
    }
  };

  const validateCodeAuth = () => {
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(process.env.REACT_APP_RECAPTCHA_CLIENT, {
          action: "validate_captcha",
        })
        .then(function (tokenRecaptcha) {
          onClickHandleValidate(
            msisdn,
            tokenRecaptcha,
            tokenValue,
            otpTransactionId
          );
        });
    });
  };

  const resendCodeAuth = () => {
    setDialogObject({
      title: "",
      description: [""],
      function: () => { },
      isOpen: false,
    })
    logger({ name: "ResendCodeToken" });
    setButtonDisabled(true)
    setTime(EXPIRATION_TIME);
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(process.env.REACT_APP_RECAPTCHA_CLIENT, {
          action: "validate_captcha",
        })
        .then(function (tokenRecaptcha) {
          onClickHandleCodeAuthentication(msisdn, tokenRecaptcha, true);
        });
    });
  };

  return (
    <Container>
      <Row>
        <Col xs={12} lg={10} className="mdn-Offset-lg-1 aling-content">
          <Heading className="mcm-StepTitle mdn-u-marginBottom--md">Código de segurança</Heading>
          <Text body className="mdn-u-marginBottom--xs">
            Enviamos um código de segurança de 6 dígitos para: {" "}
            <span>
              <strong>{handlePhoneMask(msisdn)}</strong>
            </span>
          </Text>
        </Col>
      </Row>
      <Row className="mdn-u-alignItems-lg-center">
        <Col xs={12} lg={3} className="mdn-Offset-lg-1 aling-content">
          <Text body>
            Informe  o código recebido:
          </Text>
        </Col>
        <Col xs={12} lg={3} className="aling-content">
          <Input
            id="inputToken"
            autoFocus
            number
            onKeyDown={e => exceptThisSymbols.includes(e.key) && e.preventDefault()}
            onBlur={({ target }) => handleInputError(target)}
            onInput={handleOnChange}
            onWheel={(e) => e.target.blur()}
            className="inputCodeAuthentication"
            errorMessage="Utilize 6 caracteres númericos"
            key={'sms-token-value-validation'}
            value={tokenValue}
          >
            Digite aqui o código recebido
          </Input>
        </Col>
        <Col xs={12} lg={4} className="aling-content">
          <div className="mdn-Tag mdn-Tag--feedback mdn-u-alignItems-xs-start">
            <i className={"mdn-Tag-icon mdn-Icon-informacao mdn-Icon--md"}></i>
            <p className="mdn-Tag mdn-Tag--feedback">
              O código enviado expira em: {" "}
              {minuteLeft}
              {minuteRight}
              :
              {secondLeft}
              {secondRight}
            </p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={10} className="mdn-Offset-lg-1 aling-content">
          <Button
            primary
            className="buttonGroup"
            disabled={buttonDisabled}
            {...propsButtonContinue}
          >
            Continuar
          </Button>
          <Button secondary className="buttonGroup"
            onClick={() => {
              onClickBackStep()
              reportGA4({ customTitle: 'validacao_do_token:voltar' })
            }}>
            Voltar
          </Button>
        </Col>
      </Row>
    </Container>
  );
};
export default AuthenticationStep;
